import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import CommonDropdown from '../../../components/common-dropdown/CommonDropdown';
import { COMMON_PAGE_SIZE_OPTIONS } from '../../../constants';
import SearchInput from '../../../components/common-inputs/SearchInput';
import { changeCustomersTableSettings } from '../../../redux/customers/customersReducer';

import scss from './CustomersFilters.module.scss';

const CustomersFilters = () => {
  const { t } = useTranslation('customers');
  const dispatch = useDispatch();

  const { size, searchQuery } = useSelector((state) => state.customers.customersTableSettings);

  const handleSearch = useCallback(
    (newSearch) => {
      dispatch(changeCustomersTableSettings({ searchQuery: newSearch }));
    },
    [dispatch],
  );

  const handleChangeTableSize = useCallback(
    (newSize) => {
      dispatch(changeCustomersTableSettings({ size: newSize }));
    },
    [dispatch],
  );

  return (
    <div className={scss.filtersWrapper}>
      <SearchInput size='sm' value={searchQuery} onChange={handleSearch} maxWidth={320} />

      <WithLabel variant={LABEL_STYLES.ROW} label={t('show')} maxWidth={160}>
        <CommonDropdown value={size} onSelect={handleChangeTableSize} options={COMMON_PAGE_SIZE_OPTIONS} />
      </WithLabel>
    </div>
  );
};

export default memo(CustomersFilters);
